import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import ProjectHelper from 'src/app/helpers/project-helper';
import Board from 'src/app/model/product/board/board';
import Product from 'src/app/model/product/product';
import { SubProject } from 'src/app/model/project/sub-project';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';

@Component({
  selector: 'design-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DesignProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'currentDesignDate',
      'currentConfirmedPlacementDate',
      'company',
      'detailedProductType',
      'productSize',
      'designInfo',
      'designer',
      'photo',
      'siteVisitNeeded',
      'externalSupplierNeeded',
      'displayStatus',
      'star'
    ];
  }

  protected getLocalStorageKey(): string {
    return 'DesignProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'statusSubstatus/vv,Afhaling,Aanpassing,Concept,Nieuw,In_behandeling/Ontwerp';
  }

  public getPageTitle(): string {
    return 'Ontwerp';
  }

  // Override
  public getDefaultSort(): string {
    return 'currentDesignDate';
  }

  // Override
  protected preProcessProjects(projects: SubProject[]): void {
    if (projects == null) {
      return;
    }

    super.preProcessProjects(projects);
    projects.forEach(p => {
      ProjectHelper.calculateNeedExternalSupplier(p);
      if (
        p.project != null &&
        CollectionHelper.isPopulated(p.project.products)
      ) {
        p.project.products.forEach(prod => this.preprocessProduct(prod));
      }
    });
  }

  private preprocessProduct(product: Product) {
    if (ProductHelper.isBoard(product)) {
      ProductHelper.calculateTableBoardDisplay(<Board>product);
    }
  }
}
